import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useCursor } from '../context/CursorContext';

const quickLinks = [
  { label: 'For Brands', path: '/for-brands' },
  { label: 'Creators', path: '/creators' },
  { label: 'Community', path: '/community' },
  { label: 'Partner Deals', path: '/partner-deals' },
  { label: 'Careers', path: '/careers' },
  { label: 'Brand Kit', path: '/brand' },
];

const socialLinks = [
  { label: 'Twitter / X', url: 'https://x.com/TheMoonMediaHQ' },
  { label: 'YouTube', url: 'https://youtube.com/@Crypto-Kid' },
];

export const Footer = () => {
  const { setLabel } = useCursor();

  return (
    <footer className="border-t border-white/5 py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo + Contact */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <Logo size="sm" />
            </Link>
            <p className="text-white/30 text-sm mb-4">Web3 Creator Marketing Agency</p>
            <div className="space-y-1">
              <a href="mailto:brands@themoonmedia.com" className="block text-green-500 text-sm font-semibold hover:text-green-400 transition-colors">
                brands@themoonmedia.com
              </a>
              <a href="mailto:partners@themoonmedia.com" className="block text-white/30 text-xs hover:text-white/50 transition-colors">
                partners@themoonmedia.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-white/50 text-[10px] uppercase tracking-wider font-semibold mb-4">Quick Links</p>
            <div className="space-y-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block text-white/30 text-sm hover:text-green-500 transition-colors duration-300"
                  onMouseEnter={() => setLabel(link.label)}
                  onMouseLeave={() => setLabel('')}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Socials */}
          <div>
            <p className="text-white/50 text-[10px] uppercase tracking-wider font-semibold mb-4">Follow Us</p>
            <div className="space-y-2">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-white/30 text-sm hover:text-green-500 transition-colors duration-300"
                  onMouseEnter={() => setLabel(link.label)}
                  onMouseLeave={() => setLabel('')}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/20 text-xs">&copy; {new Date().getFullYear()} The Moon Media. All rights reserved.</p>
          <Link
            to="/get-started"
            className="text-green-500 text-xs font-semibold uppercase tracking-wider hover:text-green-400 transition-colors"
            onMouseEnter={() => setLabel('Start')}
            onMouseLeave={() => setLabel('')}
          >
            Get Started &rarr;
          </Link>
        </div>
      </div>
    </footer>
  );
};
